export const compressImage = async (file: File, maxKB: number = 100): Promise<File> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target?.result as string;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;

        // Max dimension limit
        const MAX_WIDTH = 1080;
        const MAX_HEIGHT = 1080;

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          return resolve(file); // Fallback to original
        }

        ctx.drawImage(img, 0, 0, width, height);

        // Binary search for quality
        let low = 0.0;
        let high = 1.0;
        let quality = 0.8;
        let resultBlob: Blob | null = null;
        let iterations = 0;

        const attemptCompression = () => {
          canvas.toBlob((blob) => {
            if (!blob) {
              return resolve(file);
            }

            resultBlob = blob;
            const sizeKB = blob.size / 1024;

            if (iterations > 6 || (sizeKB <= maxKB && sizeKB > maxKB * 0.8)) {
              // Good enough
              // Create new file name replacing old extension with .webp
              const newName = file.name.replace(/\.[^/.]+$/, "") + ".webp";
              resolve(new File([blob], newName, { type: 'image/webp' }));
            } else if (sizeKB > maxKB) {
              high = quality;
              quality = (low + high) / 2;
              iterations++;
              attemptCompression();
            } else {
              low = quality;
              quality = (low + high) / 2;
              iterations++;
              attemptCompression();
            }
          }, 'image/webp', quality);
        };

        attemptCompression();
      };
      img.onerror = () => resolve(file);
    };
    reader.onerror = () => resolve(file);
  });
};
